module.exports = __webpack_public_path__ + "1d18360bc27b0017085ee0a71a198391.png";